/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Pricing_Get_StartedInputs */

const en_common_pricing_get_started = /** @type {(inputs: Common_Pricing_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get Started`)
};

const zh_common_pricing_get_started = /** @type {(inputs: Common_Pricing_Get_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`立即开始`)
};

/**
* | output |
* | --- |
* | "Get Started" |
*
* @param {Common_Pricing_Get_StartedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_pricing_get_started = /** @type {((inputs?: Common_Pricing_Get_StartedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Pricing_Get_StartedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_pricing_get_started(inputs)
	return zh_common_pricing_get_started(inputs)
});
export { common_pricing_get_started as "common.pricing.get_started" }